import { useEffect, useRef, useMemo } from 'react';
import { useLocation } from 'react-router';
import { BottomNavigation } from 'components/common/bottomNavigation/BottomNavigation';
import './ChatEmbed.css';

export const ChatEmbed = () => {
    const location = useLocation();
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const chatFrontUrl = process.env.REACT_APP_CHAT_FRONT_URL || 'http://localhost:3010';

    // URL 경로에서 채팅 관련 경로 추출 (/chat, /chat/room/:id, /chat/participants/:id)
    const getChatPath = () => {
        const path = location.pathname;
        if (path.startsWith('/chat')) {
            return path;
        }
        return '/chat';
    };

    // 토큰을 URL 파라미터로 전달하여 chat-front와 인증 공유
    const iframeSrc = useMemo(() => {
        const accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');
        const basePath = `${chatFrontUrl}${getChatPath()}`;

        if (accessToken) {
            const params = new URLSearchParams();
            params.set('accessToken', accessToken);
            if (refreshToken) {
                params.set('refreshToken', refreshToken);
            }
            return `${basePath}?${params.toString()}`;
        }
        return basePath;
    }, [chatFrontUrl, location.pathname]);

    // moi-front와 wiz-chat-front 간 메시지 통신
    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            // origin 검증
            if (!chatFrontUrl.startsWith(event.origin)) {
                return;
            }

            console.log('Message from chat:', event.data);

            // 토큰 요청 처리
            if (event.data?.type === 'REQUEST_AUTH_TOKEN') {
                const accessToken = localStorage.getItem('accessToken');
                const refreshToken = localStorage.getItem('refreshToken');

                if (accessToken && iframeRef.current?.contentWindow) {
                    iframeRef.current.contentWindow.postMessage({
                        type: 'AUTH_TOKEN',
                        accessToken,
                        refreshToken
                    }, chatFrontUrl);
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [chatFrontUrl]);

    return (
        <div className="chat-embed-wrapper">
            <div className="chat-embed-container">
                <iframe
                    ref={iframeRef}
                    src={iframeSrc}
                    title="채팅"
                    className="chat-iframe"
                    allow="microphone; camera"
                />
            </div>
            <BottomNavigation />
        </div>
    );
};
